import { sendReport } from "./sendReport";

export const CPU_MAX_GAMES = 3;

function readUserData() {
  try {
    const raw =
      localStorage.getItem("userData") ||
      sessionStorage.getItem("userData") ||
      "{}";
    return JSON.parse(raw) || {};
  } catch {
    return {};
  }
}

function userIdOf(userData) {
  return String(userData?.userId ?? userData?.userid ?? userData?.id ?? "").trim();
}

async function post(path, userData, body) {
  const token = `${userData?.sessionId ?? ""}&${userData?.organizationId ?? ""}`;
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    const err = new Error(data?.message || `${path} failed`);
    err.data = data;
    throw err;
  }
  return data;
}

/** { gamesPlayed, gamesLeft, maxGames, points, reportId, time } */
export async function fetchCpuStatus() {
  const userData = readUserData();
  return post("connect4CpuStatus", userData, {
    userId: userIdOf(userData),
    email: userData?.email || "",
    name: userData?.name || "",
  });
}

/** ExtraMile's report/add response shape varies by user type; take the first id we find. */
function extractReportId(apiRes) {
  const candidates = [
    apiRes?.reportId,
    apiRes?.data?.reportId,
    apiRes?.data?.id,
    apiRes?.data?._id,
    apiRes?.report?.id,
    apiRes?.id,
  ];
  const found = candidates.find((v) => v != null && String(v).trim() !== "");
  return found != null ? String(found).trim() : null;
}

/**
 * Record a finished CPU game on our backend, then push the running point
 * total to ExtraMilePlay (report/add on the first game, report update after).
 */
export async function reportCpuGameResult({ roundId, result }) {
  const userData = readUserData();
  const userId = userIdOf(userData);

  const summary = await post("connect4CpuResult", userData, {
    userId,
    email: userData?.email || "",
    name: userData?.name || "",
    roundId,
    result,
  });
  if (summary.duplicate) return summary;

  const apiRes = await sendReport({
    sessionId: userData.sessionId,
    role: userData.role,
    token: userData.token || null,
    name: userData.name,
    userId,
    gameId: userData.gameId || "",
    organizationId: userData.organizationId,
    points: summary.points,
    time: summary.time,
    reportId: summary.reportId || null,
    ans: "",
  });

  if (!summary.reportId) {
    const reportId = extractReportId(apiRes);
    if (reportId) {
      await post("connect4CpuReportId", userData, { userId, reportId });
    } else {
      console.warn("ExtraMile report response had no reportId:", apiRes);
    }
  }

  return summary;
}
